export const constructExternalArticleLink = (kb) => {
  const article = kb.articles?.[kb.currentArticleId];
  return `${kb?.config.knowledgeBaseDomain}${article?.lang}/${article?.slug}-${article?.hash}`;
};
